import styled, { css } from 'styled-components';

export const ReplyRounded = styled.span<{ isreply: string }>`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--colPointBlue);
  ${(props) =>
    props.isreply === 'true' &&
    css`
      color: var(--colBlack);
    `}
`;
